import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Organizations from './pages/Organizations';
import Community from './pages/Community';
import Planning from './pages/Planning';
import Learning from './pages/Learning';
import CourseDetail from './pages/CourseDetail';
import LessonPlayer from './pages/LessonPlayer';
import Accreditation from './pages/Accreditation';
import Admin from './pages/Admin';
import WeeklyPlans from './pages/WeeklyPlans';
import YomevCourses from './pages/YomevCourses';
import YomevCourseEditor from './pages/YomevCourseEditor';
import Library from './pages/Library';
import LibraryDocument from './pages/LibraryDocument';
import LibraryAdmin from './pages/LibraryAdmin';
import LibraryDocumentEditor from './pages/LibraryDocumentEditor';
import Analytics from './pages/Analytics';
import MyProgress from './pages/MyProgress';
import CourseProgress from './pages/CourseProgress';
import OrganizationMembers from './pages/OrganizationMembers';
import QuizTake from './pages/QuizTake';
import QuizReports from './pages/QuizReports';
import MyQuizzes from './pages/MyQuizzes';
import MyCertification from './pages/MyCertification';
import AccreditationDashboard from './pages/AccreditationDashboard';
import PlanStudioDashboard from './pages/PlanStudioDashboard';
import PlanStudioWizard from './pages/PlanStudioWizard';
import PlanStudioReview from './pages/PlanStudioReview';
import WeekMapsAdmin from './pages/WeekMapsAdmin';
import ActivitiesAdmin from './pages/ActivitiesAdmin';
import GlossaryAdmin from './pages/GlossaryAdmin';
import PlanStudioAnalytics from './pages/PlanStudioAnalytics';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/organizations"
            element={
              <ProtectedRoute>
                <Layout>
                  <Organizations />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/org/:orgId/planning"
            element={
              <ProtectedRoute>
                <Layout>
                  <Planning />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/org/:orgId/accreditation"
            element={
              <ProtectedRoute>
                <Layout>
                  <Accreditation />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/org/:orgId/members"
            element={
              <ProtectedRoute>
                <Layout>
                  <OrganizationMembers />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/community"
            element={
              <ProtectedRoute>
                <Layout>
                  <Community />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning"
            element={
              <ProtectedRoute>
                <Layout>
                  <Learning />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/course/:courseId"
            element={
              <ProtectedRoute>
                <Layout>
                  <CourseDetail />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/lesson/:lessonId"
            element={
              <ProtectedRoute>
                <Layout>
                  <LessonPlayer />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/my-progress"
            element={
              <ProtectedRoute>
                <Layout>
                  <MyProgress />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning/progress/:courseId"
            element={
              <ProtectedRoute>
                <Layout>
                  <CourseProgress />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Layout>
                  <Admin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/weekly-plans"
            element={
              <ProtectedRoute>
                <Layout>
                  <WeeklyPlans />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/yomev/courses"
            element={
              <ProtectedRoute>
                <Layout>
                  <YomevCourses />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/yomev/courses/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <YomevCourseEditor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/yomev/courses/:courseId/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <YomevCourseEditor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/library"
            element={
              <ProtectedRoute>
                <Layout>
                  <Library />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/library/:documentId"
            element={
              <ProtectedRoute>
                <Layout>
                  <LibraryDocument />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/library"
            element={
              <ProtectedRoute>
                <Layout>
                  <LibraryAdmin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/library/documents/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <LibraryDocumentEditor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/library/documents/:documentId/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <LibraryDocumentEditor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Layout>
                  <Analytics />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:quizId"
            element={
              <ProtectedRoute>
                <QuizTake />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:quizId/reports"
            element={
              <ProtectedRoute>
                <Layout>
                  <QuizReports />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-quizzes"
            element={
              <ProtectedRoute>
                <Layout>
                  <MyQuizzes />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-certification"
            element={
              <ProtectedRoute>
                <Layout>
                  <MyCertification />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/accreditation-dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <AccreditationDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-studio"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlanStudioDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-studio/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlanStudioWizard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-studio/review/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlanStudioReview />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-studio/admin/week-maps"
            element={
              <ProtectedRoute>
                <Layout>
                  <WeekMapsAdmin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-studio/admin/activities"
            element={
              <ProtectedRoute>
                <Layout>
                  <ActivitiesAdmin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-studio/admin/glossary"
            element={
              <ProtectedRoute>
                <Layout>
                  <GlossaryAdmin />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plan-studio/analytics"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlanStudioAnalytics />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<div className="text-center py-12"><h2 className="text-2xl font-bold text-gray-900">Sayfa bulunamadı</h2></div>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
